import { AUTH_KEY } from "@/components/constants";

const useUserToken = () => {
    const storedData = localStorage.getItem(AUTH_KEY);

    if (!storedData) {
        return null;
    }

    const userData = JSON.parse(storedData);

    return {
        accessToken: userData.accessToken,
        data: userData.data,
        isAuthenticated: !!userData.accessToken,
        clearToken: () => localStorage.removeItem(AUTH_KEY),
    };
};

export default useUserToken;
